type PagePropsType = {
    pageNo: number;
    lastPageNo: number;
    getLog: (e: any, pageNo: number) => void;
}

const PageSelect = (props: PagePropsType) => {
    const { pageNo, lastPageNo, getLog } = props;
    const clamp = (n: number) => Math.min(Math.max(n, 1), lastPageNo || 1);

    // build the window of page numbers around the current page
    const around: number[] = [];
    for (let p = pageNo - 2; p <= pageNo + 2; p++) {
        if (p >= 1 && p <= lastPageNo) around.push(p);
    }

    return (
        <div className="bl-pager">
            <button type="button" onClick={(e) => getLog(e, 1)} disabled={pageNo <= 1} title="最初へ">&laquo;</button>
            <button type="button" onClick={(e) => getLog(e, clamp(pageNo - 1))} disabled={pageNo <= 1} title="前へ">&lsaquo;</button>
            {around.map((p) => (
                <button
                    type="button"
                    key={p}
                    className={p === pageNo ? 'active' : ''}
                    onClick={(e) => getLog(e, p)}
                >
                    {p}
                </button>
            ))}
            <button type="button" onClick={(e) => getLog(e, clamp(pageNo + 1))} disabled={pageNo >= lastPageNo} title="次へ">&rsaquo;</button>
            <button type="button" onClick={(e) => getLog(e, lastPageNo)} disabled={pageNo >= lastPageNo} title="最後へ">&raquo;</button>
        </div>
    );
}

export default PageSelect;